// components
import { Typography } from '@mui/material';
import { rgbaPrimary } from 'constants/colors';

// hooks
//import { useState } from 'react';
import { useShallow } from 'zustand/shallow';
import { useContextPanelStore } from '../../ContextPanel.store';

// types
import {
  ContextPanelHeaderProps,
  ContextPanelSize
} from '../../ContextPanel.types';
import {
  // IconContainer,
  ResizeButton,
  // ResizeOptionButton,
  // ResizePanel,
  StyledHeader
} from './ContextPanelHeader.styles';
//import { Popover } from '../../../Popover';

export const ContextPanelHeader = ({
  label,
  onPanelSizeChange
}: ContextPanelHeaderProps) => {
  const { panelSize, setPanelSize } = useContextPanelStore(
    useShallow((state) => ({
      panelSize: state.panelSize,
      setPanelSize: state.control.setPanelSize
    }))
  );

  //const [isOpen, setIsOpen] = useState<boolean>(false);

  const togglePanelSize = () => {
    const newSize =
      panelSize === ContextPanelSize.COMPACT
        ? ContextPanelSize.MEDIUM
        : ContextPanelSize.COMPACT;

    handlePanelSize(newSize);
  };

  const handlePanelSize = (panelSize: ContextPanelSize) => {
    setPanelSize(panelSize);
    //setIsOpen(false);
    onPanelSizeChange?.(panelSize);
  };

  return (
    <StyledHeader role="menubar">
      <Typography role="heading" variant="h6">
        {label}
      </Typography>

      <ResizeButton
        type={
          panelSize === ContextPanelSize.COMPACT
            ? 'angles-left'
            : 'angles-right'
        }
        sx={{
          bgcolor:
            panelSize === ContextPanelSize.COMPACT
              ? rgbaPrimary(0.1)
              : 'inherit'
        }}
        size="small"
        onClick={togglePanelSize}
        color="secondary"
      />

      {/* TODO: Remove if final decision to remove has been made, or rework into 'drag handles' */}
      {/* <Popover
        id="mrp-context-panel-resize"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        showBackdrop={false}
        open={isOpen}
        onOpen={setIsOpen.bind(null, true)}
        component={
          <ResizePanel>
            <IconContainer>
              <ResizeOptionButton
                active={panelSize === ContextPanelSize.COMPACT}
                type="user"
                onClick={handlePanelSize.bind(null, ContextPanelSize.COMPACT)}
              />
              <ResizeOptionButton
                active={panelSize === ContextPanelSize.MEDIUM}
                type="user"
                onClick={handlePanelSize.bind(null, ContextPanelSize.MEDIUM)}
              />
              <ResizeOptionButton
                active={panelSize === ContextPanelSize.LARGE}
                type="user"
                onClick={handlePanelSize.bind(null, ContextPanelSize.LARGE)}
              />
            </IconContainer>
          </ResizePanel>
        }
      >
        <ResizeButton
          type="arrow-up-right-and-arrow-down-left-from-center"
          size="small"
        />
      </Popover> */}
    </StyledHeader>
  );
};
